<template lang="pug">
#app
  notifications(position="bottom center")
  IconDefs
  Layout
</template>

<script>
import IconDefs from '@c/IconDefs.vue'
import Layout from '@c/layout/Layout.vue'

export default {
  components: { IconDefs, Layout },
}
</script>

<style lang="stylus">
#app
  font-family 'Avenir', Helvetica, Arial, sans-serif
  font-family 'Montserrat', sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  color #2c3e50
</style>
